import { PackagesData } from 'pages/Account/components/pages/MyOrders/types'
import React from 'react'

interface HeaderProps {
  orderId: string
  packages: PackagesData[]
  selectedPackageIndex: number
  onPackageUpdate: (index: number) => void
}

const Header: React.FC<HeaderProps> = ({ orderId, packages, selectedPackageIndex, onPackageUpdate }) => {
  return (
    <div className="rounded-lg">
      <div className="flex flex-col gap-2">
        <p className="text-base font-normal text-gray-600">
          Número do Pedido: <span className="text-primary-700">{orderId}</span>
        </p>
        <div className="flex flex-wrap gap-2">
          {packages.map((pack, index) => (
            <div key={pack.id || index} className="flex flex-col gap-2">
              <button
                key={pack.id || index}
                onClick={() => onPackageUpdate(index)}
                className={`cursor-pointer rounded-md border-b-2 px-3 py-1 text-base font-medium transition-all ${
                  index === selectedPackageIndex
                    ? 'border-primary-700 bg-primary-50 text-primary-700'
                    : 'border-transparent text-gray-600 hover:bg-gray-100 hover:text-primary-600'
                }`}>
                Pacote {index + 1} - #{pack.id}
              </button>
              {pack.tracking_number && (
                <p className="text-base font-normal text-gray-600">
                  Código de rastreio: <span className="text-primary-700">{pack.tracking_number}</span>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Header
